<template lang="pug">
    #app.flex.flex-column.vh-100.avenir
        #top.bb.b--gray.bg-gray(style="height:70px")
            img.ma3(style="vertical-align: middle;height:30px" src="./assets/Logo-HORI-3-crop.png")
            img.mt2.mr3.absolute.right-0(style="vertical-align: middle;height:50px" src="./assets/DEM_Door_REV_H.png")
        #middle.flex.flex-auto
            #sidebar.br.b--light-gray.overflow-auto.pa2-ns(:class="{ collapsed: !sidebarOpen}")
                .container.overflow-auto.relative
                    .only-mobile.absolute.right-0.pa3(style="background:#222" @click="sidebarOpen=false" v-if="sidebarOpen") Show map
                    //- p &larr; <a href="https://unearthed.solutions/explorersa-winners">Back to winners list</a>
                    //- .pa2.bw2.br.b--light-gray
                    //- h1 Gawler Challenge results
                    FeatureInfo
                    h3 Filter by mineral
                    MineralFilter(:minerals="minerals")
                    h3 Filter by team
                    TeamFilter

            #sidebar-rim.relative.br.bg-dark-gray.b--gray.bw2(v-show="!sidebarOpen"  style="width:20px" @click="sidebarOpen = true")
            #map-container.relative.flex-auto
                Map(:minerals="minerals")
                #sidebarToggle.absolute.bg-dark-gray.f3.br.bt.bb.br--right.br-100.b--gray.bw1.pa1.pointer.grow.fw8(@click="sidebarOpen = !sidebarOpen")
                  span(v-if="!sidebarOpen") &rarr;
                  span(v-if="sidebarOpen") &larr;
                #overlay.absolute.h-100.w-100
                //- Legend
        #bottom.bt.b--light-gray.flex-none
</template>

<script>
import Map from './components/Map.vue';
import FeatureInfo from './components/FeatureInfo.vue';
import Legend from '@/components/Legend.vue';
import TeamFilter from '@/components/TeamFilter.vue';
import MineralFilter from '@/components/MineralFilter.vue';
import { EventBus } from './EventBus';
// import minerals from './minerals';

require('./minerals'); // such hack - can't make commonJS and ES module work for this one file.
window.app = {};
window.log = (...args) => {
    if ((window.location.hash || '').match(/debug/)) {
        console.log(...args);
    }
};

export default {
    name: 'app',
    components: {
        Map,
        FeatureInfo,
        Legend,
        TeamFilter,
        MineralFilter
    },
    data() {
        return {
            sidebarOpen: true,
            minerals:
                window.minerals /*: {
                Au: {
                    name: 'Gold',
                    color: 'hsl(60,100%,60%)'
                },
                Cu: {
                    name: 'Copper',
                    color: 'hsl(180,80%,50%)'
                },
                Fe: {
                    name: 'Iron',
                    color: 'hsl(30,50%,50%)'
                },
                Zn: {
                    name: 'Zinc',
                    color: 'hsl(0,0%,70%)'
                },
                Ag: {
                    name: 'Silver',
                    color: 'hsl(0,0%,100%)'
                },
                Co: {
                    name: 'Cobalt',
                    color: 'hsl(260,80%,40%)'
                },
                U: {
                    name: 'Uranium',
                    color: 'hsl(120,80%,60%)'
                },
                Ni: {
                    name: 'Nickel',
                    color: 'hsl(220,50%,30%)'
                },
                Mn: {
                    name: 'Manganese',
                    color: 'hsl(70,80%,30%)'
                },
                // Mg: {
                //     name: 'Magnesium',
                //     color: 'hsl(280,60%,80%)'
                // },
                Pt: {
                    name: 'Platinum',
                    color: 'hsl(280,60%,80%)'
                },
                // Pt: {
                //     name: 'Platinum',
                //     color: 'hsl(280,60%,80%)'
                // },
                REE: {
                    name: 'Rare-earth elements',
                    color: 'hsl(340,90%,60%)'
                },
                other: {
                    name: 'Other',
                    color: 'orange'
                },
                unknown: {
                    name: 'Unknown',
                    color: 'red'
                }
            }*/
        };
    },
    created() {
        window.app.App = this;
        EventBus.$on('select-feature', () => (this.sidebarOpen = true));
    },
    watch: {
        sidebarOpen() {
            this.$nextTick(() => window.map.resize());
        }
    }
};

require('tachyons/css/tachyons.min.css');
// require('pretty-checkbox/dist/pretty-checkbox.min.css');
</script>

<style scoped>
html,
body {
    height: 100vh;
    width: 100%;
    margin: 0;
    padding: 0;
}

#sidebarToggle:hover {
    background: hsl(220, 100%, 95%);
}

#sidebar.collapsed {
    position: absolute;
    animation-duration: 0.5s;
    animation-name: slideout;
    pointer-events: none;
    animation-fill-mode: forwards;
}

#sidebar {
    animation-duration: 0.5s;
    animation-name: slidein;
    z-index: 1;
    width: 410px;
}
.container {
    height: calc(99vh - 80px);
}
@keyframes slidein {
    from {
        transform: translate(-310px, 0);
    }
    to {
        transform: translate(0px, 0);
    }
}
@keyframes slideout {
    from {
        transform: translate(0px, 0);
    }
    99% {
        opacity: 1;
    }
    to {
        transform: translate(-310px, 0);
        opacity: 0; /* The sidebar will still be present, so we need to hide it. Relies on animation-fill-mode: forwards*/
    }
}

#sidebarToggle:hover {
    /* background: hsl(220, 100%, 95%); */
    background: hsl(0, 0%, 30%);
}

/* Exists to ensure whole sidebar animates together */
.collapsed .container {
    height: 100vh;
}

#overlay {
    pointer-events: none;
}
</style>
<style>
@media screen and (min-width: 768px) {
    .only-mobile {
        display: none;
    }
}
@media screen and (max-width: 767px) {
    .not-mobile {
        display: none;
    }
}
</style>

<style>
h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: benton-sans, sans-serif;
}
h1 {
    font-size: 40px;
    font-weight: bold;
    color: #3e3e3e;
}
h2 {
    color: #ff6600;
    font-size: 20px;
    font-weight: light;
}
h3 {
    color: #3e3e3e;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 0.25em;
}
.gc-orange {
    color: #ff6600;
}

* {
    /* color: #4c4e5d; */
    color: white;
    /* background-color: hsl(0, 0%, 98%); */
}

/* dark mode */
h1,
h2,
h3 {
    color: white;
}
p,
label {
    color: hsl(0, 0%, 90%);
}
#sidebar {
    /* background-color: hsl(0, 0%, 24.3%); */
    background-color: hsl(0, 0%, 17.3%);
}
</style>
<style lang="scss">
$pretty--color-default: #888;
$pretty--color-dark: #fff;

$pretty--color-primary: #428bca;
$pretty--color-info: #5bc0de;
$pretty--color-success: #5cb85c;
$pretty--color-warning: #f0ad4e;
$pretty--color-danger: #d9534f;

.bg-gray {
    background: hsl(0, 0%, 17.3%);
}

@import '~pretty-checkbox/src/pretty-checkbox.scss';
</style>
